module.exports = __webpack_public_path__ + "img/no_img.acaa1458.png";